import { Component, inject, DestroyRef, input, effect, output } from "@angular/core";
import { CdkDropList, type CdkDragDrop } from "@angular/cdk/drag-drop";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { DragAndDropService } from "../drag-and-drop.service";
import { DropListGroupId } from "../drag-and-drop.interface";

@Component({
    selector: "wk-drop-list",
    templateUrl: "./drop-list.component.html",
    styleUrl: "./drop-list.component.scss",
    host: {
        class: "wk-drop-list",
    },
    hostDirectives: [
        {
            directive: CdkDropList,
            inputs: [
                "cdkDropListAutoScrollDisabled",
                "cdkDropListData",
                "cdkDropListDisabled",
                "cdkDropListOrientation",
                "cdkDropListSortingDisabled",
            ],
            outputs: ["cdkDropListDropped"],
        },
    ],
    standalone: true,
})
export class DropListComponent {
    private dragAndDropService = inject(DragAndDropService);
    private dropList = inject(CdkDropList);
    private destroyRef = inject(DestroyRef);

    groupId = input<DropListGroupId>();
    autoScrollStep = input<number>(32);
    drop = output<CdkDragDrop<any[]>>();

    constructor() {
        effect(() => {
            const groupId = this.groupId();
            if (!groupId) return;

            this.dropList.id = this.dropList.element.nativeElement.id;
            this.dragAndDropService.registerDropList(groupId, this.dropList);
        });

        effect(() => {
            const groupId = this.groupId();
            const registry = this.dragAndDropService.registeredDropLists();
            if (!groupId || !registry.size) return;

            this.dropList.connectedTo = registry.get(groupId)?.connectedDropLists || [];
        });

        effect(() => {
            const step = this.autoScrollStep();
            this.dropList.autoScrollStep = step;
        });

        this.dropList.autoScrollDisabled = false;
        this.dropList.entered.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e) => this.dragAndDropService.onDropListEntered(e));
        this.dropList.dropped.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e) => {
            this.dragAndDropService.onDropListDropped(e);
            this.drop.emit(e);
        });
    }
}
